export class QuickUserCreation{
    public Email:string;
    public FirstName:string;
    public LastName:string;
    public OrganizationID:number;
    public RoleCode:string;
    public CompanyID:number;
}